/* eslint-disable */
export default {
  _MainBackground: 'MainBackground',
  _Hill: 'Hill',
  _Label_Subtitle: 'Label_Subtitle',
  _Instruct_Questions: 'Instruct_Questions',
  _Label_NumberedBalloons: 'Label_NumberedBalloons',
  _ResultCircle: 'ResultCircle',
  _Pop_Full: 'Pop_Full',
  _Label_Balloon: 'Label_Balloon',
  _Label_ResultsBonusRound: 'Label_ResultsBonusRound',
  _MrBee01: 'MrBee01',
  _Header_IncorrectAnswers: 'Header_IncorrectAnswers',
  _MrBee02: 'MrBee02',
  _BtnGoAlt: 'BtnGoAlt',
  _Wrong_Even: 'Wrong_Even',
  _Wrong_Odd: 'Wrong_Odd',
  _Label_FinalResultsSubtitle: 'Label_FinalResultsSubtitle',
  _Header_WrongGuesses: 'Header_WrongGuesses',
  _MrBee03: 'MrBee03',
  _MrBee_Sting: 'MrBee_Sting',
  _Cloud: 'Cloud',
  _Label_GoBonusRound: 'Label_GoBonusRound',
  _Balloon_Top01_Pop22: 'Balloon_Top01_Pop22',
  _Balloon_Top02_Pop22: 'Balloon_Top02_Pop22',
  _Balloon_Top03_Pop22: 'Balloon_Top03_Pop22',
  _Label_Odd: 'Label_Odd',
  _Label_FinalResultsButton: 'Label_FinalResultsButton',
  _Label_NextRound: 'Label_NextRound',
  _BtnGo: 'BtnGo',
  _Hand_Pointer: 'Hand_Pointer',
  _Label_PopThe: 'Label_PopThe',
  _Balloon_Top01: 'Balloon_Top01',
  _Label_Pop: 'Label_Pop',
  _Label_GoTryAgain: 'Label_GoTryAgain',
  _Balloon_Top04_Pop22: 'Balloon_Top04_Pop22',
  _Label_PlayAgain: 'Label_PlayAgain',
  _Header_Results: 'Header_Results',
  _smMrBee01: 'smMrBee01',
  _Label_Even: 'Label_Even',
  _Header_Round: 'Header_Round',
  _smMrBee02: 'smMrBee02',
  _smMrBee03: 'smMrBee03',
  _Balloon_Top05_Pop22: 'Balloon_Top05_Pop22',
  _Balloon_Top01_Pop11: 'Balloon_Top01_Pop11',
  _ClickCircle_Outer: 'ClickCircle_Outer',
  _smMrBee_Sting: 'smMrBee_Sting',
  _Balloon_Top02_Pop11: 'Balloon_Top02_Pop11',
  _Balloon_Top03_Pop11: 'Balloon_Top03_Pop11',
  _Header_Bonus: 'Header_Bonus',
  _Header_Final: 'Header_Final',
  _Balloon_Top04_Pop11: 'Balloon_Top04_Pop11',
  _Balloon_Top05_Pop11: 'Balloon_Top05_Pop11',
  _Label_BonusHud: 'Label_BonusHud',
  _Balloon_Top01_Pop01: 'Balloon_Top01_Pop01',
  _Balloon_Top01_Deflate02: 'Balloon_Top01_Deflate02',
  _Label_Check: 'Label_Check',
  _Balloon_Top01_Pop21: 'Balloon_Top01_Pop21',
  _Pop_Shape1: 'Pop_Shape1',
  _Balloon_Top01_Deflate01: 'Balloon_Top01_Deflate01',
  _Balloon_Top02_Pop01: 'Balloon_Top02_Pop01',
  _Balloon_Top02_Pop21: 'Balloon_Top02_Pop21',
  _Balloon_Top01_Pop02: 'Balloon_Top01_Pop02',
  _Balloon_Top02_Pop02: 'Balloon_Top02_Pop02',
  _Balloon_Top03_Pop02: 'Balloon_Top03_Pop02',
  _Balloon_Top04_Pop02: 'Balloon_Top04_Pop02',
  _Balloon_Top03_Pop01: 'Balloon_Top03_Pop01',
  _Balloon_Top03_Pop21: 'Balloon_Top03_Pop21',
  _Balloon_Top05_Pop02: 'Balloon_Top05_Pop02',
  _Balloon_Top04_Pop01: 'Balloon_Top04_Pop01',
  _Balloon_Top04_Pop21: 'Balloon_Top04_Pop21',
  _Balloon_Top05_Pop01: 'Balloon_Top05_Pop01',
  _Balloon_Top05_Pop21: 'Balloon_Top05_Pop21',
  _Balloon_Top02_Deflate01: 'Balloon_Top02_Deflate01',
  _Balloon_Top02_Deflate02: 'Balloon_Top02_Deflate02',
  _Balloon_Top03_Deflate02: 'Balloon_Top03_Deflate02',
  _Balloon_Top04_Deflate02: 'Balloon_Top04_Deflate02',
  _Balloon_Top05_Deflate02: 'Balloon_Top05_Deflate02',
  _Balloon_Top01_Deflate03: 'Balloon_Top01_Deflate03',
  _Balloon_Top01_Deflate04: 'Balloon_Top01_Deflate04',
  _Balloon_Top01_Pop12: 'Balloon_Top01_Pop12',
  _Balloon_Top02: 'Balloon_Top02',
  _Balloon_Top02_Pop12: 'Balloon_Top02_Pop12',
  _Balloon_Top03: 'Balloon_Top03',
  _Balloon_Top03_Pop12: 'Balloon_Top03_Pop12',
  _Balloon_Top02_Deflate03: 'Balloon_Top02_Deflate03',
  _Balloon_Top03_Deflate03: 'Balloon_Top03_Deflate03',
  _Balloon_Top04: 'Balloon_Top04',
  _Balloon_Top03_Deflate01: 'Balloon_Top03_Deflate01',
  _Balloon_Top04_Deflate01: 'Balloon_Top04_Deflate01',
  _Balloon_Top04_Deflate03: 'Balloon_Top04_Deflate03',
  _Balloon_Top05_Deflate03: 'Balloon_Top05_Deflate03',
  _Balloon_Top04_Pop12: 'Balloon_Top04_Pop12',
  _Balloon_Top05: 'Balloon_Top05',
  _Balloon_Top05_Pop12: 'Balloon_Top05_Pop12',
  _Balloon_Top05_Deflate01: 'Balloon_Top05_Deflate01',
  _Label_Round: 'Label_Round',
  _ClickCircle_Inner: 'ClickCircle_Inner',
  _Balloon_Top02_Deflate04: 'Balloon_Top02_Deflate04',
  _Balloon_Top03_Deflate04: 'Balloon_Top03_Deflate04',
  _Balloon_Top04_Deflate04: 'Balloon_Top04_Deflate04',
  _Balloon_Top05_Deflate04: 'Balloon_Top05_Deflate04',
  _RoundIndictor_off: 'RoundIndictor_off',
  _RoundIndictor_on: 'RoundIndictor_on',
}